module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0103.jpg?v=fb30095c";